// extracted by mini-css-extract-plugin
export default {"wrapper":"plNPeWY_lC","shapeWrapper":"d9NI8rHboX","top":"RLNEiZbGBo","bottom":"jCgn08l4ed","reverse":"fZdanwHOyg"};